import { render } from "./wordright.vue?vue&type=template&id=6249b48e"
import script from "./wordright.vue?vue&type=script&lang=js"
export * from "./wordright.vue?vue&type=script&lang=js"

import "./wordright.vue?vue&type=style&index=0&id=6249b48e&lang=scss"

import exportComponent from "E:\\develop\\company\\gw\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__